export const SALES_OF_GOODS = 'sale'
export const RETURN = 'return'
export const GIFT = 'gift'
export const COMMERCIAL_SAMPLE = 'commercial_sample'
export const DOCUMENTS = 'documents'
export const MIXED = 'mixed'
export const OTHER = 'other'
